import './TableProgressBar.scss';
import ProgressBarImport from '@ramonak/react-progress-bar';
import { GreenHeat100, Neutral300 } from '../../utils/colors';

// The package's CJS build (`exports.default = ProgressBar`) gets double-wrapped by Vite's
// rolldown-based dep optimizer: a default import resolves to `{ default: ProgressBar }` at
// runtime rather than the component itself, even though the shipped .d.ts claims otherwise.
// Verified empirically (logged the import's runtime shape) — unwrap it here once.
const hasDefaultExport = (value: unknown): value is { default: typeof ProgressBarImport } =>
  typeof value === 'object' && value !== null && 'default' in value;

const ProgressBar = hasDefaultExport(ProgressBarImport)
  ? ProgressBarImport.default
  : ProgressBarImport;

const BAR_WIDTH = '75%';

interface TableProgressBarProps {
  label: string;
  maxCompleted: number;
  value: number;
}

export const TableProgressBar = ({ label, maxCompleted, value }: TableProgressBarProps) => (
  <div className='table-progress-bar-wrapper'>
    <ProgressBar
      baseBgColor={Neutral300}
      bgColor={GreenHeat100}
      borderRadius='0'
      className='table-progress-bar'
      completed={value}
      customLabel={label}
      height='14px'
      labelAlignment='outside'
      labelClassName='progress-bar-label'
      maxCompleted={maxCompleted}
      width={BAR_WIDTH}
    />
  </div>
);
